import {TableStateModel} from './table-state.model';

export class UserTableStatesModel {

  defaultTableStateName: string = null;

  tableStates: TableStateModel[] = [];

}
